import React, { useEffect, useState, Fragment, useRef } from 'react'
// import { Button, Col, div, Row } from 'react-bootstrap';
import { DebounceInput } from 'react-debounce-input';
import Loading from '../assetLibComponents/Loading'
import Toggle from '../Toggle'
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon  } from "@heroicons/react/24/outline";
import { fetchUserList, deleteUser, fetchTimezoneList, saveTimezone, getVisiblity, postVisiblity } from '../../redux/actions/settingActions';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import { Combobox } from '@headlessui/react';
import { getTokenData } from '../../redux/actions/chatAiActions';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const SettingAccount = (props) => {
  const dispatch = useDispatch();
  const fetchTimeList = useSelector((state) => state.setting.fetchTimeList?.list);
  const currentTimezone = useSelector((state) => state.setting.fetchTimeList?.user_timezone);
  const visiblityStatus = useSelector((state) => state.setting.fetchZoiVibility?.is_shown);
  const tokenData = useSelector((state) => state.chatAi.tokenData);
  const isLoading = useSelector((state) => state.setting.loading);
  const authToken = props.authToken;
  
  const [query, setQuery] = useState('')
  const [selectedPerson, setSelectedPerson] = useState(null)
  const [enabled, setEnabled] = useState(false)

  useEffect(()=>{
    if(visiblityStatus && visiblityStatus === "1"){
      setEnabled(true)
    }else{
      setEnabled(false)
    }
  },[visiblityStatus])


  // useEffect(()=>{
  //   const value = enabled ? "1" :"0";
  //   if(visiblityStatus && visiblityStatus !== value){
  //     dispatch(postVisiblity(props.authToken,value));
  //   }

  // },[enabled])

  const handleToggle = (e) =>{
    const value = e ? "1" :"0";
    if(visiblityStatus && visiblityStatus !== value){
      dispatch(postVisiblity(props.authToken,value));
    }
    setEnabled(e)
  }




  const filteredPeople = query === '' ? fetchTimeList : fetchTimeList.filter((timezone) => { return timezone.toLowerCase().includes(query.toLowerCase())})
  
  useEffect(() => {
    dispatch(fetchUserList(props.authToken, ""));
    dispatch(fetchTimezoneList(props.authToken, ""));
    dispatch(getVisiblity(props.authToken));
    dispatch(getTokenData(props.authToken));
  }, []);

  
  useEffect(() => {
    setSelectedPerson(currentTimezone)
  }, [currentTimezone])

  return (
     <>
      {isLoading && <Loading />}
        <>
        <div className="px-0">
          <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto">General</div>             
          </div>
          <div className="mt-6 max-sm:mt-4 flow-root">
            <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle sm:px-6 lg:px-8">
                <Combobox as="div" value={selectedPerson} className={"w-full flex items-center h-full"} onChange={(event) => {
                  setSelectedPerson(event);
                  dispatch(saveTimezone(authToken, event));
                }}>
                  <Combobox.Label className="flex items-center text-sm mr-24 font-medium leading-6 text-gray-900">Timezone</Combobox.Label>
                  <div className="relative flex">
                    <Combobox.Input
                      className="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                      onChange={(event) => {
                        setQuery(event.target.value);
                      }}
                      displayValue={(timezone) => timezone?.replaceAll("_"," ")}
                    />
                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                      <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </Combobox.Button>

                    {filteredPeople?.length > 0 && (
                      <Combobox.Options className="absolute top-[90%] z-10 mt-1 max-h-60 w-full listing overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {filteredPeople.map((timezone) => (
                          <Combobox.Option
                            key={timezone}
                            value={timezone}
                            className={({ active }) =>
                              classNames(
                                'relative cursor-default select-none py-2 pl-3 pr-9',
                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900'
                              )
                            }
                          >
                            {({ active, selected }) => (
                              <>
                                <span className={classNames('block truncate', selected && 'font-semibold')}>{timezone?.replaceAll("_"," ")}</span>
                                {selected && (
                                  <span
                                    className={classNames(
                                      'absolute inset-y-0 right-0 flex items-center pr-4',
                                      active ? 'text-white' : 'text-[var(--brand-primary)]'
                                    )}
                                  >
                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                  </span>
                                )}
                              </>
                            )}
                          </Combobox.Option>
                        ))}
                      </Combobox.Options>
                    )}
                  </div>
                </Combobox>
              </div>
            </div>
          </div>
          <div className="mt-6 max-sm:mt-4 flow-root">
            <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle sm:px-6 lg:px-8">
                <Combobox as="div" value={selectedPerson} className={"w-full flex items-center h-full"}>
                  <Combobox.Label className="flex items-center text-sm mr-[5.3rem] font-medium leading-6 text-gray-900">Zoi Visibility</Combobox.Label>
                  <Toggle disabled={tokenData?.used_prompts < tokenData?.total_prompts ? false : true} enabled={enabled} setEnabled={setEnabled} handleToggle={handleToggle}/>
                </Combobox>
              </div>
            </div>
          </div>
        </div>
        
        </>
    </>
    )
}

export default SettingAccount;